window.site = (window.site || {});

/**
 * Init Mobile Menu related scripts
 * @class Site
 * @static
 */
site.sidePanel = (function sidePanel() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Query DOM elements inside init() after DOMContentLoaded
    const $switches = document.querySelectorAll('#sidepanel');
    const sidePanelCloseButtons = document.querySelectorAll('[data-close-sidepanel]');
    const sidePanelOverlay = document.querySelector('.sidepanel-overlay');
    const sidePanel = document.querySelector('.sidepanel');

    if (!sidePanel || !sidePanelOverlay) {
      return false;
    }

    $switches.forEach(function($switch) {
      $switch.addEventListener("click", function(e){
        e.preventDefault();
        sidePanel.classList.add('opened');
        sidePanelOverlay.classList.add('opened');
      });
    });

    sidePanelCloseButtons.forEach(function(btn) {
      btn.addEventListener("click", function() {
        sidePanel.classList.remove('opened');
        sidePanelOverlay.classList.remove('opened');
      });
    });



    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}());
